import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
export function Layout() {
  const location = useLocation();
  const navLinkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `text-xs tracking-[0.2em] font-medium transition-colors ${isActive ? 'text-blue-400' : 'text-white/80 hover:text-white'}`;
  return <div className="min-h-screen bg-[#fdf9e6] text-[#0a0e2e]" data-id="element-10">
      <header className="bg-[#0a0e2e] text-white" data-id="element-11">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between" data-id="element-12">
          <NavLink to="/" className="text-sm font-semibold tracking-[0.2em]" data-id="element-13">
            UXATWORK
          </NavLink>
          <nav className="flex items-center gap-8 sm:gap-12" data-id="element-14">
            <NavLink to="/" end className={navLinkClass} data-id="element-15">
              HOME
            </NavLink>
            <NavLink to="/work" className={navLinkClass} data-id="element-16">
              WORK
            </NavLink>
            <NavLink to="/about" className={navLinkClass} data-id="element-17">
              ABOUT
            </NavLink>
          </nav>
        </div>
      </header>

      <AnimatePresence mode="wait" data-id="element-18">
        <motion.main key={location.pathname} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-19">
          <Outlet data-id="element-20" />
        </motion.main>
      </AnimatePresence>

      <footer className="max-w-6xl mx-auto px-6 sm:px-10 py-12 mt-20 border-t border-[#0a0e2e]/10 text-sm text-[#0a0e2e]/60 flex flex-col sm:flex-row justify-between gap-4" data-id="element-21">
        <span data-id="element-22">© {new Date().getFullYear()} Adomas — UX at Work</span>
        <span data-id="element-23">Chicago, IL</span>
      </footer>
    </div>;
}